import { CancelApplication } from "../../areas/action/cancelApplication/cancelApplication";

 

class MainMenuDirective implements ng.IDirective {
    restrict = 'AEC';
    controllerAs = 'ctrl';
    controller = MainMenuController;
    bindToController = true;
    templateUrl = 'controls/mainMenu/mainMenu.html';
}


class MainMenuController {
        
    isApplicant;
    unreadMessages;
    displayName;
    applicationId;
    isSocial;
    isOfficeUser;
    isLoggedIn;
    isPreLoggedIn;
    acceptedTC;
    isNavCollapsed = true;
    href;
    isAtTBM;

    static $inject = ['$scope', 'Communication', 'Auth', 'AccessLevel', '$uibModal', '$window', '$rootScope'];
    constructor(private $scope, private Communication, private Auth, private AccessLevel, private $uibModal, private $window, private $rootScope) {

        this.href = $scope.href;

        AccessLevel
            .promise()
            .then((userLevels) => {
                // When user has just registered, we dont have applicant userLevel but role is 'Pre'
                if (userLevels.has('applicant') || Auth.user.role == 'PRE' || Auth.user.role == 'PRE_INT') {
                    this.isApplicant = true;
                    this.isPreLoggedIn = Auth.user.role == 'PRE'; //it appears only on registeration->agency selection step


                    //cancel should display for applicant login and pre interview form also at tbm status, so I placed inside
                    this.isAtTBM = (Auth.user.roleDetails && Auth.user.roleDetails.status == 'TBM');
                }
            });



        $scope.$on('auth:user-update', () => {
            this.updateUserData(Auth.user);
        });

        this.updateUserData(Auth.user);

        this.isLoggedIn = Auth.isLoggedIn();
    }

    private updateUserData(user) {
        this.displayName = `${user.firstName} ${user.lastName}`;
        this.applicationId = (user.roleDetails && user.roleDetails.applicationId);

        if (user.roleDetails && user.roleDetails.applicationId)
            this.displayName += ` (${user.roleDetails.applicationId})`;

        this.isSocial = user.isSocial;
        this.isOfficeUser = user.isOfficer;

        if (user.roleDetails) {
            this.acceptedTC = user.roleDetails.hasLatestTermsAndConditions;
        }
    }

    cancelApplication() {
        if (this.isApplicant) {
            var action = new CancelApplication(this.$uibModal, this.$rootScope, this.applicationId);
            action.execute().then(() => {
                this.$window.location.reload();
            });
        }
    }
}



angular
    .module('app')
    .directive('mainMenu', () => new MainMenuDirective());